// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import ScrollBar from 'react-perfect-scrollbar';
import {renderIconByScoreType} from '@app/activity/messages/message-factory/message-cx/utils';
import {MdComputer} from 'react-icons/md';
import moment from 'moment';
import {Spinner} from '@app/common';
import {useSelector} from 'react-redux';
import {areAspectFeedbackMessagesFetchingSelector} from '@app/redux/feedback/selectors';

/* Displays a list of feedback Messages with their respective score value.
 */
export const FeedbackList = (props) => {
    const {cxType, list, handleClick, selectedMessage} = props;

    const isRefreshing = useSelector((state) =>
        areAspectFeedbackMessagesFetchingSelector(state),
    );

    // Get css class depending on the NPS Index
    const getNPSIndexClass = (i) => {
        return i <= 6 ? 'danger' : i < 9 ? 'warning' : 'success';
    };

    // Render badge depending on the CX Type
    const renderScoreBadge = (value) => {
        switch (cxType) {
            case 'nps':
                return (
                    <div className={`nps-circle ${getNPSIndexClass(value)}`}>
                        <span>{value}</span>
                    </div>
                );
            case 'ces':
                return renderIconByScoreType(value, 20, `${cxType}-icon`, true);
            case 'csat': {
                const csatValue =
                    value === -1
                        ? 'dissatisfied'
                        : value === 0
                        ? 'neutral'
                        : value === 1
                        ? 'satisfied'
                        : null;
                return renderIconByScoreType(
                    csatValue,
                    20,
                    `${cxType}-icon`,
                    true,
                );
            }
        }
    };

    const renderSpinner = () => {
        return (
            <div className="feedback-spinner">
                <Spinner />
            </div>
        );
    };

    return selectedMessage && !isRefreshing ? (
        <div className="list">
            <ScrollBar>
                {list.map((message, i) => (
                    <div
                        key={i}
                        className={`list-item ${
                            selectedMessage.id === message.id ? 'selected' : ''
                        }`}
                        onClick={() => handleClick(message)}
                    >
                        <div className="list-item-details">
                            <div className="list-item-user">
                                <div className="icon">
                                    <MdComputer size={16} />
                                </div>
                                <span className="user">
                                    {message.user_id || 'VISITOR'}
                                </span>
                            </div>
                            <div className="list-item-date">
                                {moment
                                    .unix(message.created_at)
                                    .format('DD/MM/YYYY • HH:mm')}
                            </div>
                        </div>
                        <div className="list-item-score-badge">
                            {renderScoreBadge(message.body.value)}
                        </div>
                    </div>
                ))}
            </ScrollBar>
        </div>
    ) : (
        <div className="list">{renderSpinner()}</div>
    );
};
